// FIXED VERSION - Key Issues Resolved
import React from "react";
import styles from "./LandingPageSection4.module.css";
import { FaPhoneAlt } from "react-icons/fa";
import { MdSupport } from "react-icons/md";
import { FaBell, FaBusinessTime } from "react-icons/fa6";

import sec1card1 from "../../../../Images/newLandingPage/sec1card1.png";
import sec1card2 from "../../../../Images/newLandingPage/sec1card2.png";
import sec1card3 from "../../../../Images/newLandingPage/sec1card3.png";
import sec1card4 from "../../../../Images/newLandingPage/sec1card4.png";

const steps = [
    {
        icon: <FaPhoneAlt />, // ✅ FIXED: Use React components, not strings
        title: "Call Comes In",
        desc: "AI answers instantly, 24/7 — no missed opportunities.",
    },
    {
        icon: <MdSupport />,  // ✅ Use proper icons
        title: "Qualifies & Captures",
        desc: "Natural conversation identifies and qualifies the lead.",
    },
    {
        icon: <FaBusinessTime />,
        title: "Logs in CRM",
        desc: "All details instantly logged in your connected CRM.",
    },
    {
        icon: <FaBell />,
        title: "Your Team Gets Alerted",
        desc: "Instant notification for high-priority leads.",
    },
];

const useCases = [
    {
        title: "Sales Teams",
        subtitle: "Automatically capture and qualify leads",
        icon: <FaPhoneAlt />,
        img: sec1card1,
    },
    {
        title: "Support Team",
        subtitle: "Handle FAQs & common queries",
        icon: <MdSupport />,
        img: sec1card2,
    },
    {
        title: "Small Businesses",
        subtitle: "Professional 24/7 call + CRM solution",
        icon: <FaBusinessTime />,
        img: sec1card3,
    },
    {
        title: "Enterprises",
        subtitle: "Scale operations & track performance",
        icon: <FaBell />,
        img: sec1card4,
    },
];

export default function LandingPageSection4() {
    return (
        <>
            {/* How It Works */}
            <section className={styles.howSection}>
                <div className={styles.container}>
                    <h2 className={styles.title}>
                        How Toxbox AI Converts Calls <span className={styles.purple}>into Customers</span>
                    </h2>
                    <div className={styles.stepsGrid}>
                        {steps.map((step, i) => (
                            <div key={step.title} className={styles.stepCard}> {/* ✅ FIXED: Unique key */}
                                <div className={styles.icon}>{step.icon}</div> {/* ✅ FIXED: Render icon component */}
                                <h3 className={styles.stepTitle}>{step.title}</h3>
                                <p className={styles.stepDesc}>{step.desc}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Use Cases */}
            <section className={styles.useCaseSection}>
                <div className={styles.containerUseCase}>
                    <div className={styles.useCaseHeader}>
                        <h2 className={styles.useCaseTitle}>Use cases</h2>
                        <p className={styles.useCaseSubtitle}>
                            Instant Lead Qualification and 24/7 Professionalism Across Every Team
                        </p>
                    </div>
                    <div className={styles.useCaseGrid}>
                        {useCases.map((item, i) => (
                            <div key={item.title} className={styles.useCaseCard}> {/* ✅ FIXED: Unique key */}
                                <img
                                    src={item.img}
                                    alt={item.title}
                                    className={styles.useCaseImg}
                                />
                                <div className={styles.overlay}>
                                    <h3 className={styles.useCaseCardTitle}>{item.title}</h3>
                                    <p className={styles.useCaseCardSubtitle}>{item.subtitle}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </>
    );
}